<mat-sidenav-container
    fullscreen
    id="sidenavContainer"
    [ngClass]="containsBanner ? 'banner-spacer' : null">
    <mat-sidenav
        #sidenav
        [class.menu-close]="!isMenuOpen"
        [class.menu-open]="isMenuOpen"
        id="sidenav"
        mode="side"
        opened>
        <mat-list id="menus">
            <div class="sidenav-header">
                <div class="logo" (click)="navigateToHome()">
                    <svg
                        fill="none"
                        height="40"
                        viewBox="0 0 454 80"
                        width="145"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#a)" fill="#fff">
                            <path
                                d="M152.054 14.447c-2.348 0-4.334 1.986-4.334 4.334v40.993c0 2.348 1.986 4.334 4.334 4.334 2.347 0 4.334-1.986 4.334-4.334V18.781c0-2.348-1.987-4.334-4.334-4.334zM197.924 28.894c-2.348 0-4.334 1.986-4.334 4.334-2.89-3.07-7.043-5.056-11.377-5.056-9.21 0-16.614 8.126-16.614 18.239 0 10.113 7.404 18.24 16.614 18.24 4.514 0 8.487-1.987 11.377-5.057 0 2.347 1.986 4.334 4.334 4.334 2.347 0 4.334-1.987 4.334-4.334V33.047c-.181-2.167-1.987-4.153-4.334-4.153zm-14.086 27.81c-5.418 0-9.932-4.514-9.932-10.293 0-5.779 4.334-10.294 9.932-10.294 5.598 0 9.932 4.515 9.932 10.294 0 5.779-4.334 10.293-9.932 10.293zM269.436 29.075c-2.167-1.084-4.695-.181-5.598 1.986l-9.571 20.045-9.572-20.045c-1.083-2.167-3.611-3.07-5.598-1.986a3.576 3.576 0 0 0-1.986 1.986l-9.571 19.865-9.571-20.046c-1.084-2.167-3.612-3.07-5.599-1.986-2.167 1.084-3.07 3.612-1.986 5.598l13.363 27.45c1.084 2.166 3.612 3.07 5.599 1.986.902-.542 1.625-1.264 1.986-2.167l9.571-19.504 9.571 19.684c1.084 2.167 3.612 3.07 5.598 1.987.903-.542 1.626-1.264 1.987-2.167l13.363-27.269c1.084-1.806.181-4.334-1.986-5.417zM310.61 28.894c-2.348 0-4.334 1.987-4.334 4.334v14.628c-.181 5.056-3.973 9.029-8.849 9.029s-8.849-4.154-8.849-9.21V33.228c0-2.348-1.986-4.334-4.334-4.334s-4.334 1.987-4.334 4.334v16.433c0 8.307 6.862 14.99 15.169 14.99 4.334 0 8.127-1.807 11.016-4.515v.722c0 7.404-4.334 10.655-10.655 10.655-3.07 0-6.681-.723-10.112-2.168-2.709-1.083-5.96.903-5.96 3.973 0 1.806 1.084 3.251 2.528 3.973 4.334 1.806 9.03 2.89 13.364 2.89 11.557-.18 19.142-7.224 19.142-18.962V33.41c.361-2.528-1.625-4.515-3.792-4.515zM341.671 28.172c-9.752 0-17.698 8.126-17.698 18.239 0 11.738 7.404 18.24 18.962 18.24 3.431 0 7.223-.723 11.016-1.987 1.625-.542 2.708-1.987 2.708-3.793 0-2.167-1.805-3.973-3.973-3.973-.361 0-.902 0-1.264.181-2.889.903-5.959 1.445-8.307 1.445-5.056 0-8.307-1.806-9.751-5.598h21.851c2.347 0 4.153-1.806 4.153-4.154v-.722c0-9.752-7.946-17.878-17.697-17.878zm-8.849 15.169c1.083-4.154 4.695-7.224 8.849-7.224 4.153 0 7.584 3.07 8.848 7.224h-17.697zM385.553 28.172c-2.89 0-6.14 1.625-8.668 4.153-.362-1.986-2.168-3.431-4.154-3.431-2.348 0-4.334 1.986-4.334 4.334v26.546c0 2.348 1.986 4.334 4.334 4.334s4.334-1.986 4.334-4.334V48.217c0-7.043 4.334-10.655 9.21-11.377 2.167-.361 3.612-2.167 3.612-4.334 0-2.348-1.987-4.334-4.334-4.334zM403.973 14.447c-2.348 0-4.334 1.986-4.334 4.334v40.993c0 2.348 1.986 4.334 4.334 4.334 2.347 0 4.334-1.986 4.334-4.334V18.781c0-2.348-1.987-4.334-4.334-4.334zM448.939 28.894c-2.348 0-4.334 1.987-4.334 4.334v14.628c-.181 5.056-3.973 9.029-8.849 9.029s-8.849-4.154-8.849-9.21V33.228c0-2.348-1.986-4.334-4.334-4.334s-4.334 1.987-4.334 4.334v16.433c0 8.307 6.862 14.99 15.169 14.99 4.334 0 8.127-1.807 11.016-4.515v.722c0 7.404-4.334 10.655-10.655 10.655-3.069 0-6.681-.723-10.112-2.168-2.709-1.083-5.96.903-5.96 3.973 0 1.806 1.084 3.251 2.528 3.973 4.335 1.806 9.03 2.89 13.364 2.89 11.557-.18 19.142-7.224 19.142-18.962V33.41c.542-2.528-1.445-4.515-3.792-4.515zM53.454 53.454c1.987 0 3.431-1.625 3.431-3.431V29.977c0-1.986-1.625-3.43-3.43-3.43-1.987 0-3.432 1.625-3.432 3.43v20.046c0 1.806 1.625 3.43 3.431 3.43z" />
                            <path
                                d="M95.711 2.528C95.35.903 93.905-.18 92.1 0L15.17 4.515c-.722.18-1.444.36-1.986.903-.361.36-.723.722-1.084 1.264L.361 31.964C0 32.686 0 33.228 0 33.95v.903c.722 4.696 4.876 13.544 15.35 13.544S29.977 39.55 30.7 34.853v-.903c0-.722 0-1.264-.361-1.805l-9.752-20.949 66.275-3.972-9.39 20.225c-.361.542-.361 1.264-.361 1.806v.903c.722 4.695 4.876 13.544 15.35 13.544 10.654 0 14.627-8.849 15.349-13.544v-.903c0-.722 0-1.264-.361-1.806L95.711 2.53zM15.35 41.355c-.542 0-5.237-.181-7.585-4.515h14.989c-.903 2.167-3.07 4.514-7.404 4.514zm6.501-11.377H8.849l6.5-13.725 6.502 13.724zm70.429-18.42l6.501 13.905H85.779l6.5-13.905zm.18 25.282c-.541 0-5.236-.18-7.584-4.515h14.989c-1.084 2.167-3.251 4.515-7.404 4.515zM100.587 54.718c-1.626-.903-3.793-.361-4.696 1.264C81.444 81.806 53.453 70.97 52.37 70.429c-1.806-.722-3.792.18-4.515 1.986-.722 1.806.18 3.793 1.987 4.515.18 0 7.765 3.07 17.517 3.07 11.196 0 25.463-3.973 34.672-20.406.903-1.806.362-3.973-1.444-4.876z" />
                        </g>
                        <defs>
                            <clipPath id="a">
                                <path d="M0 0h453.273v80H0z" fill="#fff" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <button
                    (click)="onToolbarMenuToggle()"
                    *ngIf="!isMenuOpen"
                    class="menu__icon"
                    mat-icon-button>
                    <mat-icon>menu</mat-icon>
                </button>
                <button
                    (click)="onToolbarMenuToggle()"
                    *ngIf="isMenuOpen"
                    class="menu__icon"
                    mat-icon-button>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>

            <mat-list-item class="new-case-list-item">
                <div class="new-case-wrapper">
                    <button
                        [authorized-disabled]="[
                            this.permissionScope.Cases.draft,
                            this.permissionScope.Cases.open
                        ]"
                        class="new-case-button"
                        mat-raised-button
                        (click)="openNewCaseDialog()"
                        [matTooltip]="!isMenuOpen ? 'New Case' : null">
                        <span class="new-case-button-plus">
                            <mat-icon class="plus_button">add</mat-icon>
                        </span>
                        <span class="new-case-button-text">New Case</span>
                    </button>
                </div>
            </mat-list-item>
            <div
                class="scroll_div"
                [ngClass]="containsBanner ? 'banner-spacer-scroll-div' : null">
                <div class="first_column">
                    <mat-list-item
                        *authorized-hide="[
                            this.permissionScope.Dashboard.view
                        ]">
                        <button
                            [routerLinkActive]="'active'"
                            class="menu-item"
                            mat-flat-button
                            routerLink="/app/dashboards"
                            [matTooltip]="!isMenuOpen ? 'Dashboards' : null">
                            <a class="menu-link">
                                <div class="icon_div">
                                    <mat-icon class="menu__icon">
                                        dashboard
                                    </mat-icon>
                                </div>
                                <span class="menu-item-text">Dashboards</span>
                            </a>
                        </button>
                    </mat-list-item>

                    <mat-list-item
                        *authorized-hide="[this.permissionScope.Diary.read]">
                        <button
                            [routerLinkActive]="'active'"
                            class="menu-item"
                            mat-flat-button
                            routerLink="/app/diary"
                            [matTooltip]="!isMenuOpen ? 'Diary' : null">
                            <a class="menu-link">
                                <div class="icon_div">
                                    <mat-icon class="menu__icon">
                                        event
                                    </mat-icon>
                                </div>
                                <span class="menu-item-text">Diary</span>
                            </a>
                        </button>
                    </mat-list-item>
                    <mat-list-item
                        *authorized-hide="[this.permissionScope.Cases.search]">
                        <button
                            class="menu-item"
                            mat-flat-button
                            routerLinkActive="active"
                            [matTooltip]="!isMenuOpen ? 'Cases' : null">
                            <a class="menu-link" routerLink="/app/cases">
                                <div class="icon_div">
                                    <mat-icon class="menu__icon">
                                        folder_shared
                                    </mat-icon>
                                </div>
                                <span class="menu-item-text">Cases</span>
                            </a>
                        </button>
                    </mat-list-item>
                    <mat-list-item
                        *authorized-hide="[this.permissionScope.Claim.read]">
                        <button
                            class="menu-item"
                            mat-flat-button
                            routerLinkActive="active"
                            [matTooltip]="!isMenuOpen ? 'Claims' : null">
                            <a class="menu-link" routerLink="/app/claims">
                                <div class="icon_div">
                                    <mat-icon class="menu__icon">
                                        gavel
                                    </mat-icon>
                                </div>
                                <span class="menu-item-text">Claims</span>
                            </a>
                        </button>
                    </mat-list-item>
                    <ng-container *ngIf="callFeatureEnabled">
                        <mat-list-item
                            *authorized-hide="[this.permissionScope.Call.read]">
                            <button
                                class="menu-item inbox-menu-item"
                                mat-flat-button
                                routerLinkActive="active"
                                [matTooltip]="!isMenuOpen ? 'Calls' : null">
                                <a class="menu-link" routerLink="/app/calls">
                                    <div class="icon_div">
                                        <mat-icon class="menu__icon">
                                            phone
                                        </mat-icon>
                                    </div>
                                    <span
                                        *ngIf="isMenuOpen"
                                        class="menu-item-text">
                                        Calls
                                    </span>
                                </a>
                            </button>
                        </mat-list-item>
                    </ng-container>

                    <mat-list-item
                        *authorized-hide="[this.permissionScope.Client.read]">
                        <button
                            class="menu-item inbox-menu-item"
                            mat-flat-button
                            routerLinkActive="active"
                            [matTooltip]="!isMenuOpen ? 'Clients' : null">
                            <a class="menu-link" routerLink="/app/client">
                                <div class="icon_div">
                                    <mat-icon class="menu__icon">
                                        account_box
                                    </mat-icon>
                                </div>
                                <span *ngIf="isMenuOpen" class="menu-item-text">
                                    Clients
                                </span>
                            </a>
                        </button>
                    </mat-list-item>

                    <mat-list-item>
                        <button
                            class="menu-item inbox-menu-item"
                            mat-flat-button
                            routerLinkActive="active"
                            [matTooltip]="!isMenuOpen ? 'AI Assistant' : null">
                            <a
                                class="menu-link"
                                href="https://www.lawyerly.chat/"
                                rel="noopener noreferrer"
                                target="_blank">
                                <div class="icon_div">
                                    <mat-icon class="menu__icon">
                                        smart_toy
                                    </mat-icon>
                                </div>
                                <span *ngIf="isMenuOpen" class="menu-item-text">
                                    AI Assistant
                                </span>
                            </a>
                        </button>
                    </mat-list-item>

                    <mat-list-item
                        *authorized-hide="[
                            this.permissionScope.ServiceProvider.search
                        ]">
                        <button
                            class="menu-item inbox-menu-item"
                            mat-flat-button
                            routerLinkActive="active"
                            [matTooltip]="
                                !isMenuOpen ? 'Service Providers' : null
                            ">
                            <a
                                class="menu-link"
                                routerLink="/app/serviceproviders">
                                <div class="icon_div">
                                    <mat-icon class="menu__icon">
                                        business
                                    </mat-icon>
                                </div>
                                <span *ngIf="isMenuOpen" class="menu-item-text">
                                    Service Providers
                                </span>
                            </a>
                        </button>
                    </mat-list-item>
                </div>
                <div class="second_column">
                    <mat-list-item
                        *authorized-hide="[this.permissionScope.User.search]">
                        <button
                            class="menu-item"
                            mat-flat-button
                            routerLinkActive="active"
                            [matTooltip]="!isMenuOpen ? 'Users' : null">
                            <a
                                class="menu-link"
                                [routerLink]="['usermanagement']">
                                <div class="icon_div">
                                    <mat-icon>people</mat-icon>
                                </div>
                                <span class="menu-item-text">Users</span>
                            </a>
                        </button>
                    </mat-list-item>

                    <mat-list-item
                        *authorized-hide="[this.permissionScope.Payments.read]">
                        <button
                            class="menu-item"
                            mat-flat-button
                            routerLinkActive="active"
                            [matTooltip]="!isMenuOpen ? 'Payments' : null">
                            <a class="menu-link" [routerLink]="['payments']">
                                <div class="icon_div">
                                    <mat-icon>payment</mat-icon>
                                </div>
                                <span class="menu-item-text">Payments</span>
                            </a>
                        </button>
                    </mat-list-item>

                    <mat-list-item
                        *authorized-hide="[
                            this.permissionScope.AdminSettings.view
                        ]">
                        <button
                            class="menu-item"
                            mat-flat-button
                            routerLinkActive="active"
                            [matTooltip]="
                                !isMenuOpen ? 'Admin Settings' : null
                            ">
                            <a class="menu-link" [routerLink]="['/admin']">
                                <div class="icon_div">
                                    <mat-icon>settings</mat-icon>
                                </div>
                                <span class="menu-item-text"
                                    >Admin Settings
                                </span>
                            </a>
                        </button>
                    </mat-list-item>
                    <mat-list-item>
                        <button
                            class="menu-item"
                            mat-flat-button
                            routerLinkActive="active"
                            [matTooltip]="
                                !isMenuOpen ? 'Help & Support' : null
                            ">
                            <a
                                class="menu-link"
                                href="https://lawyerly.gitbook.io/lawyerly/"
                                rel="noopener noreferrer"
                                target="_blank">
                                <div class="icon_div">
                                    <mat-icon>help</mat-icon>
                                </div>
                                <span class="menu-item-text"
                                    >Help & Support
                                </span>
                            </a>
                        </button>
                    </mat-list-item>
                </div>
                <div class="third_column">
                    <mat-list-item>
                        <button (click)="toggleNotifications()" mat-mini-fab>
                            <div class="menu-item tabs">
                                <mat-icon
                                    class="toolbar-icon"
                                    matBadge="{{
                                        (unreadNotificationCount$ | async) > 0
                                            ? (unreadNotificationCount$ | async)
                                            : ''
                                    }}"
                                    matBadgeColor="#ff6f61"
                                    matBadgePosition="after">
                                    notifications
                                </mat-icon>
                            </div>
                        </button>
                    </mat-list-item>
                </div>
            </div>
        </mat-list>
        <mat-list>
            <div class="user_state">
                <div
                    class="user_profile_image"
                    (click)="goToProfile()"
                    [ngClass]="!isMenuOpen ? 'closed' : ''"
                    [matTooltip]="!isMenuOpen ? 'My Profile' : null">
                    <div
                        [ngStyle]="{
                            backgroundImage:
                                'url(' +
                                authService.user.profilePictureUri +
                                ')'
                        }"
                        class="avatar"
                        mat-card-avatar></div>
                </div>
                <div *ngIf="isMenuOpen" class="user_name">
                    {{ authService.user.displayName }}
                </div>
                <div *ngIf="isMenuOpen">
                    <button mat-button (click)="onLogout()" class="menu__icon">
                        <mat-icon>logout</mat-icon>
                    </button>
                </div>
            </div>
        </mat-list>
    </mat-sidenav>

    <mat-sidenav-content
        [class.menu-close]="!isMenuOpen"
        [class.menu-open]="isMenuOpen"
        class="side__content">
        <ng-content></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>
